import React, { useState } from 'react';
import { useLocation, Router } from 'react-router-dom';
import DefinitionHandleSelect from 'Utils/DefinitionHandleSelect';
import DefinitionHandleSelectAll from 'Utils/DefinitionHandleSelectAll';
import SideBarContainer from 'Containers/SideBarContainer';
import Search from 'Components/Search';
import Title from 'Components/Title';
import DropDown from 'Components/DropDown';
import Acordion from 'Components/Acordion';
import SelectTable from 'Components/SelectTable';
import useTranslation from 'Hooks/useTranslation';
import { containerEmployee, searchContainer, findContainer, ContainerAcordion } from './style';
import useDropDown from './Hooks/useDropdown';
import useComponent from './Hooks/useComponent';
import useCourse from './Hooks/useCourse';

export default function DefinitionDepartment() {
  const location = useLocation();
  if (location?.state?.isComingFrom !== '/definicion/seleccion/departamento') {
    return <Router to="/definicion" />;
  }
  const departmentId = location?.state?.department;
  const [isLoading, setIsLoading] = useState(true);
  const { courses, terminals, categories, saveCourses, coursesByEnterprise, defaultSelectedIds } = useCourse(
    { departmentId },
    setIsLoading
  );
  const { setSearch, setTerminal, setCategory, coursesFilters } = useDropDown({
    courses,
  });
  const { thereIsComponent } = useComponent({ categories });
  const { t2 } = useTranslation('DefinitionDepartment');
  const titles = [t2('Terminal'), t2('Category')];
  const options = [terminals, categories];
  const methods = [setTerminal, setCategory];
  const [selectedRows, setSelectedRows] = useState([]);
  const [unselectedRows, setUnselectedRows] = useState([]);
  const [selectAllItems, setSelectAllItems] = useState(false);

  const disableButton = () => {
    if (defaultSelectedIds.length <= 0) {
      return !selectedRows.length > 0;
    }

    return !(selectedRows.length > 0 || unselectedRows.length > 0);
  };

  const handleSelect = (row, indx) => {
    const argPayload = {
      defaultSelectedIds,
      unselectedRows,
      selectedRows,
      setSelectedRows,
      setUnselectedRows,
      courseList: coursesFilters,
    };
    DefinitionHandleSelect(row, indx, 5, argPayload);
  };

  const handleSelectAll = () => {
    const argPayload = {
      courseList: coursesFilters,
      defaultSelectedIds,
      setUnselectedRows,
      setSelectedRows,
      setSelectAllItems,
      selectAllItems,
      unselectedRows,
    };
    DefinitionHandleSelectAll(5, argPayload);
  };

  return (
    <SideBarContainer>
      <div style={containerEmployee}>
        <Title
          title={t2('Title')}
          subtitle={t2('SubTitle')}
          textButton={t2('ButtonSave')}
          eventButton={() => saveCourses(selectedRows.concat(unselectedRows))}
          disabledButton={disableButton()}
        />
        <ContainerAcordion>
          <Acordion
            title={t2('AcordionCompany')}
            information={coursesByEnterprise}
            thereIsComponent={thereIsComponent}
            limit={4}
          />
        </ContainerAcordion>
        <div style={searchContainer}>
          <div style={{ width: '40%' }}>
            <Search setData={setSearch} placeholder={t2('Search')} />
          </div>
          <div style={findContainer}>
            {titles.map((title, index) => {
              const id = title + index;
              return <DropDown key={id} title={title} options={options[index]} setData={methods[index]} />;
            })}
          </div>
        </div>
        <SelectTable
          information={coursesFilters}
          headers={[t2('Name'), t2('Terminal'), t2('TimeCourse'), t2('Category')]}
          limit={4}
          thereIsComponent={thereIsComponent}
          floatingMessage={t2('SelectedCourses')}
          selectedRows={selectedRows}
          event={handleSelect}
          selectAllEvent={handleSelectAll}
          selectAllStatus={selectAllItems}
          isLoading={isLoading}
        />
      </div>
    </SideBarContainer>
  );
}
